
import "./components.css";

const Footer = () => {
    return (
        <div className="footer w-full p-0 m-0 block">
            <footer className="sticky-footer bg-white py-2">

                <div className="copyright text-center my-auto">
                    <span>&copy; 2026 SQL. All rights reserved.</span>
                </div>
            </footer>
        </div>
    )
}

export default Footer